var React = require('react');

function DropdownOrange (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 5.217 0 L 0.021 6 L 10.413 6 L 5.217 0 Z","fill":"#FCB34E","transform":"matrix(-1, 0, 0, -1, 10.434, 6)"}));
}

DropdownOrange.defaultProps = {"width":"12","height":"6","viewBox":"0 0 10.433333396911621 6","fill":"none"};

module.exports = DropdownOrange;

DropdownOrange.default = DropdownOrange;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/dropdown-orange.svg
// module id = 328
// module chunks = 0